import { Anchor, Box, Button } from '@zillow/constellation-10';

import { useGetFullUser } from '../../hooks/queries/user';

import { paths as zrmPaths } from '../../utils/zrmPathsManifest';

import SignInCTA from '../SignInCTA';

import { DEFAULT_BUTTON_SIZE, isButtonSize } from './buttonSize';
import { toSafeEmbedUrl } from './toSafeEmbedUrl';
import VideoCtaButton from './VideoCtaButton';

const monetizationPageLink =
  'https://www.zillow.com/rental-manager/c/property-management-services/?utm_source=zillow&utm_medium=zrm-landing-page&utm_campaign=launch-property-management-services';
const POST_FIRST_LISTING_URL_QUERY = '?postingPath=true';

type Props = {
  attrs?: { size?: string; videoCtaLabel?: string; videoUrl?: string };
  canAccessLandingPageMonetization?: boolean;
  trackOptimizelyEvent?: (arg: string) => void;
};

const LandingPageCTA = ({ attrs, canAccessLandingPageMonetization = false, trackOptimizelyEvent }: Props) => {
  const { data: userData, isLoading } = useGetFullUser();
  const size = isButtonSize(attrs?.size) ? attrs.size : DEFAULT_BUTTON_SIZE;
  const videoCtaLabel = attrs?.videoCtaLabel?.trim();
  const videoUrl = toSafeEmbedUrl(attrs?.videoUrl);

  const {
    summary: { totalListingCount },
  } = userData;

  const hasAnyListings = !!totalListingCount;

  return (
    <>
      <Box
        css={{
          display: 'flex',
          flexDirection: { base: 'column', md: 'row' },
          flexWrap: { md: 'wrap' },
          gap: '400',
          justifyContent: 'flex-start',
        }}
      >
        {isLoading ? (
          <Button emphasis="filled" loading size={size} tone="brand">
            List your properties for free
          </Button>
        ) : hasAnyListings ? (
          <Anchor onClick={() => trackOptimizelyEvent?.('HeroCtaViewProperties')} href={zrmPaths.propertiesPage}>
            <Button emphasis="filled" size={size} tone="brand">
              View your properties
            </Button>
          </Anchor>
        ) : (
          <Anchor
            onClick={() => trackOptimizelyEvent?.('HeroCtaPostListingFree')}
            href={`${zrmPaths.propertiesPage}${POST_FIRST_LISTING_URL_QUERY}`}
          >
            <Button emphasis="filled" size={size} tone="brand">
              List your properties for free
            </Button>
          </Anchor>
        )}
        {canAccessLandingPageMonetization && (
          <Anchor onClick={() => trackOptimizelyEvent?.('ZRMViewPaidServicesHeroClick')} href={monetizationPageLink}>
            {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
            <Button emphasis="outlined" size={size} tone="brand" css={{ width: '184px' }}>
              View paid services
            </Button>
          </Anchor>
        )}
        {videoCtaLabel && videoUrl && <VideoCtaButton label={videoCtaLabel} size={size} videoUrl={videoUrl} />}
      </Box>

      {!isLoading && <SignInCTA />}
    </>
  );
};

export default LandingPageCTA;
